/* eslint-disable */
export default {
'inline-box-v2':
`<script type="text/javascript">
  var bookero_config = {
    id: '{{ BOOKERO_ID }}',
    container: 'bookero',
    type: 'standard',
    position: '',
    plugin_css: true,
    lang: 'pl'
  };

  (function() {
  var d = document, s = d.createElement('script');
  s.src = '{{ BOOKERO_DOMAIN }}/plugin/v2/js/bookero-compiled.js';
  d.body.appendChild(s);
  })();
</script>`,
'sticky-box-v2':
`<script type="text/javascript">
  var bookero_config = {
    id: '{{ BOOKERO_ID }}',
    container: 'bookero',
    type: 'sticky',
    position: 'bottom-right',
    plugin_css: true,
    lang: 'pl'
  };

  (function() {
  var d = document, s = d.createElement('script');
  s.src = '{{ BOOKERO_DOMAIN }}/plugin/v2/js/bookero-compiled.js';
  d.body.appendChild(s);
  })();
</script>`,
'weekly-box-v2':
`<script type="text/javascript">
  var bookero_config = {
    id: '{{ BOOKERO_ID }}',
    container: 'bookero',
    type: 'full',
    position: '',
    plugin_css: true,
    lang: 'pl'
  };

  (function() {
  var d = document, s = d.createElement('script');
  s.src = '{{ BOOKERO_DOMAIN }}/plugin/v2/js/bookero-compiled.js';
  d.body.appendChild(s);
  })();
</script>`,
'monthly-box-v2':
`<script type="text/javascript">
  var bookero_config = {
    id: '{{ BOOKERO_ID }}',
    container: 'bookero',
    type: 'calendar',
    position: '',
    plugin_css: true,
    lang: 'pl'
  };

  (function() {
  var d = document, s = d.createElement('script');
  s.src = '{{ BOOKERO_DOMAIN }}/plugin/v2/js/bookero-compiled.js';
  d.body.appendChild(s);
  })();
</script>`
};



// WEBPACK FOOTER //
// ./src/components/config/integration-codes.js